<template>
  <div class="header-box">
    <div class="main">
      <div class="active" @click="showAction">
        {{showItem.name}}
        <Icon name="arrow-down" />
      </div>
    </div>
    <ActionSheet
      v-model="actionShow"
      :actions="selectList"
      :close-on-click-action="true"
      cancel-text="取消"
      @select="onSelect"
    />
  </div>
</template>

<script>
import { ActionSheet, Icon } from "vant";
export default {
  components:{
    ActionSheet,
    Icon
  },
  computed:{
    showItem(){
      const _find = this.selectList.find(item => item.value == this.active);
      return _find || this.selectList[0] || {};
    }
  },
  data(){
    return{
      selectList:[
        {name:'全部',value:0},
        {name:'高',value:3},
        {name:'中',value:2},
        {name:'低',value:1}
      ],
      active:0,
      actionShow:false
    }
  },
  methods:{
    showAction(){
      this.actionShow = !this.actionShow;
    },
    onSelect(e,index){
      this.active = e.value
      this.$emit('messageChange',{ e,index })
    }
  }
}
</script>

<style scoped lang="less">
    .header-box{
      overflow: hidden;
      background: #fff;
      height: 80px;
      display: flex;
      align-items: center;
      .main{
        flex: 1;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        padding: 0 32px;
        line-height: 40px;
        .active{
          color: #1C0955;
        }
      }
    }
</style>
